export default __webpack_public_path__ + "static/media/phone-simple.8d50079c.svg";